"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _commonConstants = require("../../../utils/common-constants");

var _constants = require("./constants");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: {}
};
var initialStateForTagMembers = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: []
};

var users = function users() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.UsersType.USERS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        data: null
      });

    case _constants.UsersType.USERS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: {
          result: action.payload || []
        }
      });

    case _constants.UsersType.USERS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        data: null
      });

    case _constants.UsersType.USERS_RESET:
      return initialState;

    default:
      return state;
  }
};

var groups = function groups() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.GroupsType.GROUPS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        data: null
      });

    case _constants.GroupsType.GROUPS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: {
          result: action.payload || []
        }
      });

    case _constants.GroupsType.GROUPS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        data: null
      });

    case _constants.GroupsType.GROUPS_RESET:
      return initialState;

    default:
      return state;
  }
};

var tagMembers = function tagMembers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateForTagMembers;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.TagMembersType.TAG_MEMBERS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING
      });

    case _constants.TagMembersType.TAG_MEMBERS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      var data = [].concat(_toConsumableArray(state.data), _toConsumableArray(action.payload.data));

      if (action.payload.filter) {
        data = action.payload.data;
      }

      return _objectSpread(_objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS
      }, action.payload), {}, {
        data: data
      });

    case _constants.TagMembersType.TAG_MEMBERS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        data: null
      });

    case _constants.TagMembersType.TAG_MEMBERS_RESET:
      return initialStateForTagMembers;

    default:
      return state;
  }
};

var serviceIdentities = function serviceIdentities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.ServiceIdentitiesType.SERVICE_IDENTITY_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        data: null
      });

    case _constants.ServiceIdentitiesType.SERVICE_IDENTITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: {
          result: action.payload || []
        }
      });

    case _constants.ServiceIdentitiesType.SERVICE_IDENTITY_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        data: null
      });

    case _constants.ServiceIdentitiesType.SERVICE_IDENTITY_RESET:
      return initialState;

    default:
      return state;
  }
};

var tokens = function tokens() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.TokensType.TOKENS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        data: null
      });

    case _constants.TokensType.TOKENS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: {
          result: action.payload || []
        }
      });

    case _constants.TokensType.TOKENS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        data: null
      });

    case _constants.TokensType.TOKENS_RESET:
      return initialState;

    default:
      return state;
  }
};

var paginatedUsers = function paginatedUsers() {
  var _action$payload, _action$payload2, _action$payload3, _action$payload4, _action$payload5, _action$payload6, _action$payload7, _action$payload8, _action$payload9, _action$payload10;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.UserPaginatedType.USERS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        data: null
      });

    case _constants.UserPaginatedType.USERS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        result: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data,
        searchText: (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.searchText,
        page: (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.page,
        count: (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.count,
        size: (_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.size
      });

    case _constants.UserPaginatedType.USERS_SUCCESS_LOAD_MORE:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null,
        result: [].concat(_toConsumableArray(state.result), _toConsumableArray((_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : _action$payload6.data)),
        searchText: (_action$payload7 = action.payload) === null || _action$payload7 === void 0 ? void 0 : _action$payload7.searchText,
        page: (_action$payload8 = action.payload) === null || _action$payload8 === void 0 ? void 0 : _action$payload8.page,
        size: (_action$payload9 = action.payload) === null || _action$payload9 === void 0 ? void 0 : _action$payload9.size,
        count: (_action$payload10 = action.payload) === null || _action$payload10 === void 0 ? void 0 : _action$payload10.count,
        status: _commonConstants.RESOURCE_STATUS.SUCCESS
      });

    case _constants.UserPaginatedType.USERS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        data: null
      });

    case _constants.UserPaginatedType.USERS_RESET:
      return initialState;

    default:
      return state;
  }
};

var paginatedTags = function paginatedTags() {
  var _action$payload11, _action$payload12, _action$payload13, _action$payload14, _action$payload15, _action$payload16, _action$payload17, _action$payload18, _action$payload19, _action$payload20;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.UserTagsPaginatedType.USERS_TAGS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        data: null
      });

    case _constants.UserTagsPaginatedType.USERS_TAGS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        result: (_action$payload11 = action.payload) === null || _action$payload11 === void 0 ? void 0 : _action$payload11.data,
        searchText: (_action$payload12 = action.payload) === null || _action$payload12 === void 0 ? void 0 : _action$payload12.searchText,
        page: (_action$payload13 = action.payload) === null || _action$payload13 === void 0 ? void 0 : _action$payload13.page,
        count: (_action$payload14 = action.payload) === null || _action$payload14 === void 0 ? void 0 : _action$payload14.count,
        size: (_action$payload15 = action.payload) === null || _action$payload15 === void 0 ? void 0 : _action$payload15.size
      });

    case _constants.UserTagsPaginatedType.USERS_TAGS_SUCCESS_LOAD_MORE:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null,
        result: [].concat(_toConsumableArray(state.result), _toConsumableArray((_action$payload16 = action.payload) === null || _action$payload16 === void 0 ? void 0 : _action$payload16.data)),
        searchText: (_action$payload17 = action.payload) === null || _action$payload17 === void 0 ? void 0 : _action$payload17.searchText,
        page: (_action$payload18 = action.payload) === null || _action$payload18 === void 0 ? void 0 : _action$payload18.page,
        size: (_action$payload19 = action.payload) === null || _action$payload19 === void 0 ? void 0 : _action$payload19.size,
        count: (_action$payload20 = action.payload) === null || _action$payload20 === void 0 ? void 0 : _action$payload20.count,
        status: _commonConstants.RESOURCE_STATUS.SUCCESS
      });

    case _constants.UserTagsPaginatedType.USERS_TAGS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        data: null
      });

    case _constants.UserTagsPaginatedType.USERS_TAGS_RESET:
      return initialState;

    default:
      return state;
  }
};

var membersReducer = (0, _redux.combineReducers)({
  users: users,
  groups: groups,
  serviceIdentities: serviceIdentities,
  tokens: tokens,
  tagMembers: tagMembers,
  paginatedUsers: paginatedUsers,
  paginatedTags: paginatedTags
});
var _default = membersReducer;
exports.default = _default;